import { m } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { AnimatedCounter } from "./AnimatedCounter";
import { Users, FileText, Star } from "lucide-react";
export const SocialProofStats = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });
  const stats = [{
    icon: Users,
    value: 500,
    suffix: "+",
    label: "Designers"
  }, {
    icon: FileText,
    value: 50000,
    suffix: "+",
    label: "Documents Generated"
  }, {
    icon: Star,
    value: 4.9,
    suffix: "★",
    label: "Average Rating"
  }];
  return <div ref={ref} className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto mb-6" style={{ contain: "layout style" }}>
      {stats.map((stat, index) => <m.div key={index} initial={{
      opacity: 0,
      scale: 0.8
    }} animate={inView ? {
      opacity: 1,
      scale: 1
    } : {
      opacity: 0,
      scale: 0.8
    }} transition={{
      delay: index * 0.1,
      duration: 0.5
    }} className="glass-card p-6 rounded-2xl text-center hover-lift py-[21px]"
    style={{ willChange: "transform, opacity" }}>
          <stat.icon className="h-8 w-8 text-purple mx-auto mb-3" />
          <div className="text-4xl font-bold gradient-text mb-2">
            <AnimatedCounter value={stat.value} suffix={stat.suffix} />
          </div>
          <div className="text-muted-foreground">{stat.label}</div>
        </m.div>)}
    </div>;
};